export default {
    data: () => {
        return {

        }
    },
    methods: {
        snakeCaseToCamelCase(string) {
            return string.replace(/[^a-zA-Z0-9]+(.)/g, (m, char) => {
                return char.toUpperCase();
            });
        },
        camelCaseToSnakeCase(string) {
            return string.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
        },
        getDeepValue(obj, path, defaultValue) {
            if (!path)
                return defaultValue
            const keys = path.replace(/\[(\d+)\]/g, '.$1')
                            .split('.')
                            .filter(key => key !== '');
    
            const value = keys.reduce((currentObj, key) => {
                return (currentObj && currentObj[key] !== undefined) ? currentObj[key] : undefined;
            }, obj);

            return (value !== undefined) ? value : defaultValue;
        }

    }
}
